import React from "react";
import {
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarFilterButton
} from "@material-ui/data-grid";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    tableToolbarContainer: {
        paddingLeft: theme.spacing(3),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(3),

    }
}));

export const TableToolbar = () => {
    const classes = useStyles();
    return (
        <div className={classes.tableToolbarContainer}>
            <GridToolbarContainer>
                <GridToolbarColumnsButton/>
                <GridToolbarFilterButton/>
                <GridToolbarExport/>
            </GridToolbarContainer>
        </div>
    )
};